module.exports = __webpack_public_path__ + "static/media/file.37fcfcd8.svg";